import apiTool from './index';

const ADD_CLIENT_URL = 'clients/';
const ADD_USER_URL = 'clients/<client_id>/users/';

const GET_CLIENTS_URL = 'clients/?no_page';
const GET_CLIENT_URL = 'clients/';
const GET_CLIENT_USERS_URL = 'clients/<client_id>/users/?no_page';
const GET_CLIENT_CHANGES_URL = 'clients/<client_id>/changes/?no_page';

const UPDATE_CLIENT_URL = 'clients/<client_id>/';
const UPDATE_USER_URL = 'clients/<client_id>/users/<user_id>/';

const DELETE_USER_URL = 'clients/<client_id>/users/<user_id>/';

export default {
  addClient(payload) {
    return apiTool.post(ADD_CLIENT_URL, payload);
  },
  addUser(payload) {
    return apiTool.post(
      ADD_USER_URL.replace('<client_id>', payload.client_id),
      payload.data
    );
  },

  getClients() {
    return apiTool.get(GET_CLIENTS_URL);
  },
  getClient(clientId) {
    return apiTool.get(GET_CLIENT_URL + clientId + '/');
  },
  getClientUsers(clientId) {
    return apiTool.get(GET_CLIENT_USERS_URL.replace('<client_id>', clientId));
  },
  getClientChanges(clientId) {
    return apiTool.get(GET_CLIENT_CHANGES_URL.replace('<client_id>', clientId));
  },

  updateClient(payload) {
    return apiTool.patch(
      UPDATE_CLIENT_URL.replace('<client_id>', payload.client_id),
      payload.data
    );
  },
  updateUser(payload) {
    return apiTool.patch(
      UPDATE_USER_URL.replace('<client_id>', payload.client_id).replace(
        '<user_id>',
        payload.user_id
      ),
      payload.data
    );
  },

  deleteUser(payload) {
    return apiTool.delete(
      DELETE_USER_URL.replace('<client_id>', payload.client_id).replace(
        '<user_id>',
        payload.user_id
      )
    );
  }
};
